import { useEffect, useState } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import { SaveButton } from '@shared/components/SaveButton';
import { initializeValues } from '@shared/commonFunctions';
import { ILenderUtilityTabProps } from '../LenderUtilityTabs';
import { TStatesAndZips } from '../../interfaces';
import { requestUpdateIcsAndExcs } from './queries';
import { incsAndExcsFormSchema } from './validation';
import { IncsAndExcsForm } from './IncsAndExcsForm';

const getUpdatedStringArray = (array: string[]) => {
  const updatedArray: string[] = [];
  array.forEach((val) => {
    if (val && val.length) {
      updatedArray.push(val.trim());
    }
  });

  return updatedArray;
};

export const IncsAndExcs = ({ data, lenderId }: ILenderUtilityTabProps) => {
  const [statesAndZips, setStatesAndZips] = useState(data?.statesAndZips);

  useEffect(() => {
    if (data?.statesAndZips) {
      setStatesAndZips(data.statesAndZips);
    }
  }, [data?.statesAndZips]);

  const handleSubmit = async(values: TStatesAndZips, formikActions: FormikHelpers<TStatesAndZips>) => {
    const payload = {
      excludedStates: values.excludedStates,
      includedZipCodes: getUpdatedStringArray(String(values.includedZipCodes).split(',')),
      includedContactIds: getUpdatedStringArray(String(values.includedContactIds).split(',')),
    };

    await requestUpdateIcsAndExcs(lenderId, payload);
    formikActions.setSubmitting(false);
  };

  const initialValues = initializeValues({
    excludedStates: statesAndZips?.excludedStates ?? [],
    includedZipCodes: (statesAndZips?.includedZipCodes ?? []).join(', '),
    includedContactIds: (statesAndZips?.includedContactIds ?? []).join(', '),
  });

  return (
    <Formik
      enableReinitialize
      validationSchema={incsAndExcsFormSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <SaveButton disabled={!props.dirty} />

          <IncsAndExcsForm {...props} lenderId={lenderId} />
        </Form>
      )}
    </Formik>
  );
};
